import { render, staticRenderFns } from "./UserGroupList.vue?vue&type=template&id=3cfe2dd8&"
import script from "./UserGroupList.vue?vue&type=script&lang=js&"
export * from "./UserGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports